import React, { useEffect } from "react";
import SubSpecialitiesInfo from "../../data/SubSpecialitiesInfo";
import { useParams, useLocation } from "react-router-dom";
import ModalitiesSection from "./ModalitiesSection";
import VerifiedIcon from "@mui/icons-material/Verified";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import BookAnAppointment from "./BookAnAppointment";
export default function SpecialitiesPage() {
  const { slug } = useParams();
  const { hash } = useLocation();

  useEffect(() => {
    // Function to attempt scrolling to the target element
    const scrollToHash = () => {
      if (hash) {
        const targetId = hash.replace("#", "");
        const element = document.getElementById(targetId);
        if (element) {
          // Calculate navbar height (adjust based on your navbar's actual height)
          const navbarHeight = 250; // Adjust this value as needed
          const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: elementPosition - navbarHeight,
            behavior: "smooth",
          });
        } else {
          console.warn(`Element with ID ${targetId} not found`);
          // Scroll to top if hash is invalid
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      } else {
        // Scroll to top if no hash
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    };

    // Initial attempt
    scrollToHash();

    // Retry after a short delay to account for AOS or DOM rendering
    const timer = setTimeout(scrollToHash, 500);

    // Cleanup timer on unmount
    return () => clearTimeout(timer);
  }, [hash]);

  const service = SubSpecialitiesInfo.find((s) => s.slug === slug);
  if (!service) return <p className="text-white">Service not found</p>;
  return (
    <div>
          <title>{service.metaDescription}</title>
        <meta
      name="description"
      content={service.metaTitle} />
      <div className="text-black font-robout">
        {/* Hero Section */}
        <div className="relative bg-white pt-52 pb-52 px-4 sm:px-8">
          {/* Foreground Content */}
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start relative ">
            {/* Left Side */}
            <div>
              <h1
                data-aos="fade-right"
                className=" pe-8 md:pe-16 text-3xl md:text-[3rem] lg:text-[3.5rem] xl:text-[5.5rem] font-bold md:leading-[1] text-[#d78558] font-robout"
              >
                {service.title}
              </h1>
              <h2
                data-aos="fade-right"
                data-aos-delay="100"
                className=" text-xl md:text-[1.5rem]  mt-7 font-robout w-[80%]"
              >
                {service.subdescription}
              </h2>
            </div>
          </div>
        </div>
        {/* Full Width Image */}
        <div className="relative -mt-24">
          <img
            src={service.bannerimage}
            alt={service.title}
            className="w-full h-auto object-cover"
          />
        </div>
      </div>
      <div>
        <section className="py-32 mt-24  w-[90%] lg:w-[60%] mx-auto text-center" data-aos="fade-up"
              data-aos-delay="300">
          <p className="font-robout text-[20px] lg:text-[30px] text-white font-bold">
            {service.description}
          </p>
        </section>
      </div>
      <div>
        {service.whychoose && service.whychoose.length > 0 && (
          <section className="py-32 w-full lg:w-[80%] mx-auto text-white">
            {service.whychoose.map((item, index) => {
              // Split the question at the comma
              const [firstPart, secondPart] = item.question.split(", ");

              return (
                <div
                  key={index}
                  className="flex flex-col lg:flex-row lg:justify-between lg:items-center justify-center items-center md:space-x-10 space-y-6 md:space-y-0"
                >
                  {/* Left Column - Question */}
                  <div className="lg:w-1/2 flex justify-center lg:justify-start items-center text-center lg:text-left"   data-aos="fade-right"
              data-aos-delay="300">
                    <h3 className="2xl:text-[70px] xl:text-[3rem] text-5xl font-bold font-robout text-[#d78558] leading-snug capitalize">
                      {firstPart}
                      <br />
                      {secondPart}
                    </h3>
                  </div>

                  {/* Right Column - Answer List */}
                  <div className="lg:w-1/2">
                    <ul className="list-disc list-outside pl-5 space-y-4 xl:text-[1.33rem] md:text-lg text-lg lg:ps-0 md:px-8 px-4 text-left font-robout"   data-aos="fade-left"
              data-aos-delay="300">
                      {item.answer.map((point, i) => (
                        <li key={i} className="mb-2 flex flex-row gap-4">
                          <span className="flex-shrink-0 text-2xl text-[#d78558]">
                            <VerifiedIcon fontSize="30px" />
                          </span>
                          <span>{point}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              );
            })}
          </section>
        )}
      </div>
      <div>
        {service.whymatters && service.whymatters.length > 0 && (
          <section className="py-32 w-full lg:w-[80%] mx-auto text-white">
            {service.whymatters.map((item, index) => (
              <div
                key={index}
                className="flex flex-col lg:flex-row lg:justify-between lg:items-center justify-center items-center md:space-x-10 space-y-6 md:space-y-0"
              >
                {/* Left Column - Image */}
                <div className="lg:w-1/2 pb-5 lg:pb-0 flex justify-center items-center lg:justify-start" data-aos="zoom-in" >
                  <img
                    src={item.image}
                    alt={service.title}
                    className="w-[90%] h-auto object-cover"
                  />
                </div>

                {/* Right Column - Content */}
                <div className="lg:w-1/2" data-aos="fade-up" data-aos-delay="300" >
                  {/* Question */}
                  <h3 className="2xl:text-[55px] xl:text-[3rem] text-4xl leading-[65px] font-bold mb-10 font-robout text-[#d78558] text-center lg:text-left">
                    {item.question}
                  </h3>
                  {/* Answer List */}
                  <ul className="list-disc list-outside pl-5 space-y-4 xl:text-[1.33rem] md:text-lg text-lg lg:ps-0 md:px-8 px-4 text-left font-robout">
                    {item.answer.map((point, i) => (
                      <li key={i} className="mb-2 flex flex-row gap-4">
                        <span className="flex-shrink-0 text-2xl text-[#d78558]">
                          <VerifiedIcon fontSize="30px" />
                        </span>
                        <span>{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </section>
        )}
      </div>
      <ModalitiesSection />
      {/* <div className="max-w-[75%] mx-auto">
        {service.conditionsDiagnosed && (
          <div className="my-16">
            <div className="2xl:text-[44px] xl:text-5xl  text-4xl text-left font-robout font-bold pb-4 lg:pb-0 ">
              <h3 className="font-robout uppercase text-[#d78558] font-black text-xl leading-normal md:leading-[5rem] md:text-[4.8rem] aos-init aos-animate">
                {service?.conditionsDiagnosed?.title}
              </h3>
            </div>
            <div className="xl:text-xl md:text-xl sm:text-lg text-lg mb-16  text-left font-robout">
              <p className="my-4">
                {service?.conditionsDiagnosed?.description}
              </p>
            </div>
            <div className="grid 2xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 gap-14 mt-8">
              {service?.conditionsDiagnosed?.points.map((item, index) => (
                <div
                  className=" border-[2px] border-[#ffffff57] p-4 rounded-3xl 3xl:h-72 2xl:h-[17rem] lg:h-auto h-auto flex justify-center flex-col gap-4"
                  key={index}
                >
                  <h4 className="text-2xl font-bold text-[#d78558]">
                    {item.title}
                  </h4>
                  <p className="text-lg text-white">{item.description}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div> */}
      {/* <div>
        <div className="py-8 sm:py-12 md:py-16 lg:py-20 xl:py-[8.75rem]">
          <div className="px-4 sm:px-6 md:px-8 lg:px-10 ">
        
            <div className="mb-8 sm:mb-10 md:mb-20 text-center max-w-[95rem] mx-auto ">
              <span
                data-aos="fade-up"
                className="font-robout  uppercase  text-[#d78558] font-black text-xl leading-normal md:leading-[5rem] md:text-[4.8rem]"
              >
                Get prepared for {service.title}
              </span>
            </div>

          
            <ul className="space-y-6 sm:space-y-8 md:space-y-10 max-w-7xl mx-auto font-robout">
              {service.preparation.map((item, index) => (
                <li
                  key={index}
                  className="flex flex-col md:flex-row md:items-start md:justify-between border-b border-white border-opacity-15 py-6 md:py-8"
                >
                  <span
                    data-aos="fade-right"
                    data-aos-delay={`${(index + 1) * 100}`}
                    className={`font-robout md:w-2/5 w-full font-semibold ${item.color} text-3xl md:text-4xl lg:text-[2.5rem] leading-tight mb-4 md:mb-0 md:max-w-[20rem]`}
                  >
                    {item.title}
                  </span>

                 
                  <ul
                    data-aos="fade-left"
                    data-aos-delay={`${(index + 1) * 100}`}
                    className="font-robout md:w-3/5 w-full text-white text-[1.1rem] md:text-xl lg:text-[1.3rem] leading-relaxed md:max-w-[31.35rem] space-y-4"
                  >
                    {item.description.map((point, i) => (
                      <li key={i} className="flex items-start gap-3">
                        <VerifiedIcon className="text-[#d78558] text-lg mt-1" />
                        <span>{point}</span>
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div> */}
      {service.faqs.length >= 2 && (
        <div className="flex justify-center items-start 2xl:px-16 xl:px-10 lg:px-8 md:px-5 max-w-[90%] lg:max-w-[80%] mx-auto py-32">
          <div>
            <h2 className="text-[#d78558] sm:text-5xl font-robout text-3xl py-8 w-full font-black">
              FAQs
            </h2>
            <Box
              data-aos="fade-right"
              data-aos-delay="300"
              sx={{ width: "100%" }}
            >
              {service.faqs.map((faq, index) => (
                <Accordion
                  key={index}
                  elevation={0}
                  disableGutters
                  sx={{
                    borderBottom: "1px solid #fafaf6a4",
                    "&::before": { display: "none" },
                    boxShadow: "none",
                    backgroundColor: "transparent",
                  }}
                >
                  <AccordionSummary
                    expandIcon={
                      <ArrowForwardIosIcon
                        sx={{ fontSize: 16, color: "white" }}
                      />
                    }
                    aria-controls={`panel${index}-content`}
                    id={`panel${index}-header`}
                    sx={{
                      paddingY: 3,
                      paddingX: 0,
                      fontWeight: "900",
                      "& .MuiAccordionSummary-content": {
                        margin: 0,
                        fontWeight: 900,
                      },
                    }}
                  >
                    <Typography>
                      <span className="font-black font-robout text-2xl ms:text-3xl text-white">
                        {faq.question}
                      </span>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ paddingX: 0, paddingBottom: 2 }}>
                    <Typography>
                      <span className="text-white md:text-xl font-lg font-robout">
                        {faq.answer}
                      </span>
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              ))}
            </Box>
          </div>
        </div>
      )}
      <BookAnAppointment />
      {/* <GetINTouch /> */}
    </div>
  );
}
